<template>
  <div class="train-details">
    <div class="block-div" v-if="TrainCheckUser">
      <off-line-component v-if="TrainData.onlineStatus == '2'" :TrainDateListArr="TrainDateListArr"
        :TrainData="TrainData"></off-line-component>
      <line-zoom-component v-else-if="TrainData.onlineStatus == '1'" :TrainDateListArr="TrainDateListArr"
        :TrainData="TrainData"></line-zoom-component>
      <div class="train-title" v-if="TrainCourseDataList.length > 0">
        <div class="title-txt">预习课程</div>
      </div>
      <div class="train-block course-info" v-if="TrainCourseDataList.length > 0">
        <div class="course-info-title">课程要求</div>
        <div class="course-info-txt">{{ TrainData && TrainData.courseRequirement }}</div>
        <div class="course-list">
          <div class="course-item" v-for="(item, index) in TrainCourseDataList" :key="index">
            <img v-if="item && item.coverMaterial" :src="item && item.coverMaterial.url" class="course-item-cover" alt="" />
            <div v-else class="course-item-cover"></div>
            <div class="tag status1" v-if="item.state === 3">
              {{ item && item.statusTxt }}
            </div>
            <div class="tag status2" v-if="item.state === 2">
              {{ item && item.statusTxt }}
            </div>
            <div class="tag status3" v-if="item.state === 1">
              {{ item && item.statusTxt }}
            </div>
            <div class="course-txt">{{ item && item.courseName }}</div>
          </div>
        </div>
      </div>
      <div class="train-title" v-if="TrainStudentListArr.length > 0">
        <div class="title-txt">学员</div>
      </div>
      <div class="train-block student-info" v-if="TrainStudentListArr.length > 0">
        <div class="student-list">
          <div class="student-item" v-for="(item, index) in TrainStudentListArr" :key="index">
            <template v-if="item.isShowSort === 'Y'">
              <div class="item-sort" v-if="item.sort === 1">
                <img src="@/assets/images/train/sort(3).png" class="sort-img" alt="" />
                <div class="sort-txt">1</div>
              </div>
              <div class="item-sort" v-if="item.sort === 2">
                <img src="@/assets/images/train/sort(2).png" class="sort-img" alt="" />
                <div class="sort-txt">2</div>
              </div>
              <div class="item-sort" v-if="item.sort === 3">
                <img src="@/assets/images/train/sort(1).png" class="sort-img" alt="" />
                <div class="sort-txt">3</div>
              </div>
              <div class="item-sort" v-if="item.sort > 3">
                <img src="@/assets/images/train/sort(4).png" class="sort-img" alt="" />
                <div class="sort-txt">{{ item && item.sort }}</div>
              </div>
            </template>
            <img v-if="item.headPicUrl" :src="item.headPicUrl" class="student-item-cover" alt="" />
            <div v-else-if="item.realName" class="student-item-cover">
              {{ item.realName.substring(0, 1) }}
            </div>
            <div v-else class="student-item-cover">...</div>
            <div class="student-item-info">
              <div class="item-flex-txt">
                <span class="item-txt">{{ item.realName }}</span>
                <span class="item-tag">｜{{ item.hospitalName }}</span>
              </div>
              <div class="student-tag" v-if="item.isShow === 'Y'">
                <div class="tag tag2">
                  {{ item.isSign === 'Y' ? '已签到' : '未签到' }}
                </div>
                <div class="tag tag2">
                  预习 {{ item.studyRatio }}
                </div>
                <div class="tag tag2">
                  <img v-if="item.evaluateScore > 0" src="@/assets/images/train/pic_stars_s@2x.png" class="start" alt="" />
                  {{ item.isEvaluate === 'Y' ? item.evaluateScore > 0 ? `评分：${item.evaluateScore}分` : '已评价' : '未评价' }}
                </div>
              </div>
            </div>
            <!-- <div class="span-btn">点击签到</div> -->
          </div>
        </div>
      </div>
      <div class="train-block cancel-block" v-if="TrainData.publishStatus === '3'">
        <div class="info">
          <div class="label">取消原因</div>
          <div class="val">{{ TrainData.cancelReason }}</div>
        </div>
        <div class="info">
          <div class="label">备注</div>
          <div class="val">{{ TrainData.cancelRemark }}</div>
        </div>
      </div>
    </div>
    <div class="block-none" v-else>
      <img src="../../assets/images/train/img_none.png" class="img-none" alt="" />
      <div class="block-none-txt">暂无权限访问</div>
    </div>
  </div>
</template>

<script>
import {
  trainDetails,
  trainDetailsCourse,
  trainDetailstudent,
  trainDetailSchedules
} from '@/api/xwzy.js'
import { BOOL_LECTURE } from '@/utils/configRoles.js'
import OffLineComponent from './components/OffLineComponent.vue'
import LineZoomComponent from './components/LineZoomComponent.vue'
import { Toast } from 'vant'
export default {
  name: 'trainDetails',
  components: {
    OffLineComponent,
    LineZoomComponent
  },
  data () {
    return {
      TrainData: {},
      TrainCourseDataList: [],
      TrainStudentListArr: [],
      TrainDateListArr: [],
      TrainCheckUser: true,
      BOOL_LECTURE
    }
  },
  mounted () {
    this.handleGetTrainDetails()
    this.handleGetStudents()
    this.handleGetCourse()
    this.handleGetSchedules()
  },
  methods: {
    // 获取活动详情
    handleGetTrainDetails () {
      const params = {
        key: this.$route.query.key
      }
      trainDetails(params).then(res => {
        this.TrainData = res.data.data
        if (!this.TrainData) {
          this.TrainCheckUser = false
          Toast(res.data.msg)
          return
        }
        window.sessionStorage.setItem('traceTitle', '学术活动-' + this.TrainData.title)
      })
    },
    // 获取活动课程
    handleGetCourse () {
      const params = {
        key: this.$route.query.key
      }
      trainDetailsCourse(params).then(res => {
        this.TrainCourseDataList = res.data.data.map((item) => {
          item.statusTxt = ''
          switch (item.state) {
            case 1:
              item.statusTxt = '已完成'
              break
            case 2:
              item.statusTxt = '进行中'
              break
            case 3:
              item.statusTxt = '未开始'
              break
          }
          return item
        })
      })
    },
    // 获取学员列表
    handleGetStudents () {
      const params = {
        key: this.$route.query.key
      }
      trainDetailstudent(params).then(res => {
        this.TrainStudentListArr = res.data.data
      }).catch(() => {
        console.log('当前活动没有学员!')
      })
    },
    handleGetSchedules () {
      const params = {
        key: this.$route.query.key
      }
      trainDetailSchedules(params).then(res => {
        this.TrainDateListArr = res.data.data
      })
    },

  }
}
</script>

<style lang="less" scoped>
.train-details {
  background: #f7f8fa;
  padding-bottom: 8px;
  box-sizing: border-box;
  min-height: 100vh;

  &.toeva {
    padding-bottom: 72px;
  }

  .train-block {
    background-color: #fff;
    border-radius: 4px;
    margin: 0 12px;
    margin-bottom: 8px;

    &.course-info {
      padding: 16px 11px;
      box-sizing: border-box;

      .course-info-title {
        font-size: 14px;
        color: #2b2b2b;
        font-weight: 600;
        margin-bottom: 9px;
        line-height: 17px;
        padding-top: 4px;
        box-sizing: border-box;
      }

      .course-info-txt {
        color: #2b2b2b;
        font-size: 12px;
        line-height: 17px;
      }

      .course-list {
        display: flex;
        margin-top: 16px;
        flex-wrap: wrap;

        .course-item {
          width: 103px;
          margin-right: 9px;
          margin-bottom: 10px;
          position: relative;

          &:nth-child(3n) {
            margin-right: 0;
          }

          .tag {
            position: absolute;
            width: 50px;
            height: 24px;
            background-color: #fbc737;
            display: flex;
            align-items: center;
            line-height: 24px;
            justify-content: center;
            font-size: 12px;
            color: #fff;
            top: 0;
            right: 0;
            border-bottom-left-radius: 12px;

            &.status1 {
              background-color: #fe8044;
            }

            &.status2 {
              background-color: #fbc737;
            }

            &.status3 {
              background-color: #7ed321;
            }
          }

          .course-item-cover {
            width: 103px;
            height: 60px;
            margin-bottom: 6px;
          }

          .course-txt {
            line-height: 17px;
            color: #2b2b2b;
            font-size: 12px;
            text-align: center;
            padding: 0 8px;
            box-sizing: border-box;
            display: -webkit-box;
            word-break: break-all;
            text-overflow: ellipsis;
            overflow: hidden;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
        }
      }
    }

    &.student-info {
      .student-info-title {
        font-size: 12px;
        color: #2b2b2b;
        font-weight: 600;
        padding-top: 18px;
        padding-left: 14px;
        box-sizing: border-box;
        line-height: 17px;
        margin-bottom: 7px;
      }

      .student-list {
        padding: 0 5px;
        box-sizing: border-box;

        .student-item {
          display: flex;
          padding: 10px 15px;
          box-sizing: border-box;
          border-bottom: 1px solid #f0f1f6;
          position: relative;
          align-items: center;

          .item-sort {
            position: absolute;
            width: 18px;
            height: 21px;
            display: flex;
            justify-content: center;
            align-content: center;
            top: 10px;

            .sort-img {
              position: absolute;
              width: 100%;
              height: 100%;
              top: 0;
              left: 0;
            }

            .sort-txt {
              color: #fff;
              font-size: 12px;
              font-weight: 500;
              position: relative;
              line-height: 18px;
            }
          }

          &:nth-last-child(1) {
            border: none;
          }

          .student-item-cover {
            width: 50px;
            height: 50px;
            margin-right: 12px;
            border-radius: 50%;
            object-fit: cover;
            background-color: #e6e6e6;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            color: #333333;
            font-weight: bold;
          }

          .student-item-info {
            flex: 1;

            .item-flex-txt {
              display: flex;

              .item-txt {
                font-size: 14px;
                color: #2b2b2b;
                line-height: 17px;
                font-weight: 500;
                margin-right: 4px;
              }

              .item-tag {
                font-size: 10px;
                color: #5b5f6a;
              }
            }

            .student-tag {
              display: flex;
              margin-top: 5px;
              align-items: center;

              .tag2 {
                margin-right: 10px;
                text-align: center;
                padding: 0 5px;
                height: 16px;
                line-height: 16px;
                border-radius: 4px;
                border: 1px solid #EB1700;
                font-size: 8px;
                color: #EB1700;
                display: flex;
                align-items: center;
                .start {
                  width: 10px;
                  height: 10px;
                  margin-right: 3px;
                }
              }
            }
          }

          .span-btn {
            width: 72px;
            height: 24px;
            border-radius: 100px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #EB1700;
            color: #fff;
            font-size: 12px;
            align-self: center;
          }
        }
      }
    }
  }

  .train-title {
    padding: 20px 0 7px 27px;

    .title-txt {
      line-height: 22px;
      font-size: 16px;
      color: #333333;
      font-weight: 600;
      position: relative;

      &::before {
        position: absolute;
        width: 4px;
        height: 12px;
        background-color: #EB1700;
        border-radius: 4px;
        left: -10px;
        content: '';
        bottom: 4px;
      }
    }
  }

  .cancel-info-title {
    font-size: 14px;
    color: #2b2b2b;
    font-weight: 600;
    margin-bottom: 5px;
    margin-top: 18px;
    margin-left: 18px;
    display: flex;
    align-items: center;

    .cancel {
      width: 12px;
      height: 12px;
      margin-right: 6px;
    }
  }

  .cancel-block {
    padding: 16px 14px;
    box-sizing: border-box;

    .info {
      display: flex;
      margin-bottom: 16px;

      &:nth-last-child(1) {
        margin-bottom: 0;
      }

      .label {
        width: 48px;
        text-align: right;
        margin-right: 12px;
        font-size: 12px;
        color: #2b2b2b;
        font-weight: 500;
      }

      .val {
        font-size: 12px;
        color: #2b2b2b;
        flex: 1;
      }
    }
  }

  .submit-btn {
    position: fixed;
    bottom: 17px;
    left: 16px;
    border-radius: 4px;
    background-color: #EB1700;
    width: 343px;
    height: 40px;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #ffffff;
    justify-content: center;
  }
}

.block-none {
  padding-top: 188px;
  box-sizing: border-box;

  .img-none {
    width: 120px;
    height: 104px;
    margin-bottom: 12px;
    margin-left: 50%;
    transform: translateX(-50%);
  }

  .block-none-txt {
    font-size: 14px;
    color: #5b5f6a;
    line-height: 20px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/xwzy/trainDetails.vue